import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors } from '@lean-body/components/styles';
import { Link } from 'react-router-dom';
export const FooterItem = (props) => {
    const { isActive, iconSrc, iconSrcActive, classObject, linkTo, label, hasNotification, isLongLabel } = props;
    const styles = StyleSheet.create({
        button: {
            textAlign: 'center',
            width: '20%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-end',
            position: 'relative',
        },
        imgContainer: {
            position: 'relative',
            height: '100%',
            display: 'flex',
            alignItems: 'flex-end',
        },
        iconContainer: {
            position: 'relative',
            width: 28,
            height: 28,
        },
        icon: {
            textAlign: 'center',
            width: 28,
            height: 28,
        },
        label: {
            display: 'block',
            color: Colors.Black,
            fontSize: 10,
            fontWeight: 400,
            letterSpacing: '0.05em',
            lineHeight: 1,
            marginBottom: 11,
        },
        activeLabel: {
            color: Colors.PrimaryDarkB,
            fontWeight: 500,
        },
        longLabel: {
            letterSpacing: '-0.05em',
        },
        hasNotification: {
            width: 5.25,
            height: 5.25,
            borderRadius: 100,
            backgroundColor: Colors.Accent,
            position: 'absolute',
            top: 0,
            right: 0,
        },
    });
    return (React.createElement(Link, { to: linkTo, className: css(styles.button) },
        React.createElement("div", { className: css(styles.imgContainer) },
            React.createElement("div", { className: css(styles.iconContainer) },
                React.createElement("img", { src: isActive ? iconSrcActive : iconSrc, className: css(styles.icon, classObject) }),
                hasNotification && React.createElement("div", { className: css(styles.hasNotification) }))),
        React.createElement("span", { className: css(styles.label, isActive && styles.activeLabel, isLongLabel && styles.longLabel) }, label)));
};
